import { render, staticRenderFns } from "./LicenseExpiration.vue?vue&type=template&id=4d7d0e82&"
import script from "./LicenseExpiration.vue?vue&type=script&lang=js&"
export * from "./LicenseExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports